<app-show-rule-tree 
    [temp]="data.ruleDoc" 
    [selectedRule]="data.selectedRule"
    (ruleSelected)="ruleSelected($event)">

</app-show-rule-tree>
